import { State } from 'app/redux';

export const getSettings = (state: State) => state.settings;
